import React, { useState, useContext } from "react";
import VideoComponent from "./VideoComponent";
import profile1 from "../img/profile-1.png";
import undrawProfile from "../img/undraw_profile.svg";
import { truncateText } from "../../utils/application-helper";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faFacebook,
//   faInstagram,
//   faLinkedin,
//   faXTwitter,
//   faYoutube,
// } from "@fortawesome/free-brands-svg-icons";
import ProfileView from "./ProfileView";
import axiosHttp from "../config/axios.interceptor";
import { AppContext } from "../contexts/AppContext";
import { useDispatch } from "react-redux";
import { getuserInfo } from "../store/actions/userActions";

const PublicSettings = ({ data: userProfile }) => {
  const appContext = useContext(AppContext);
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState({
    profile: userProfile?.o_profile || false,
    background: userProfile?.o_background || false,
    name: userProfile?.o_name || false,
    about: userProfile?.o_about || false,
    headline: userProfile?.o_headline || false,
    education: userProfile?.o_education || false,
    experience: userProfile?.o_experience || false,
    skills: userProfile?.o_skills || false,
    interest: userProfile?.o_interest || false,
  });

  const onVisibilityChangeHandler = (name) => {
    setIsVisible({ ...isVisible, [name]: !isVisible[name] });
  };

  const updateVisibilityHandler = async () => {
    try {
      const updateVisibility = await axiosHttp.post(
        `toggle-public-profile`,
        isVisible
      );
      if (updateVisibility.status === 201) {
        dispatch(getuserInfo());
        appContext.updateModalState();
      }
    } catch (error) {
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const renderMyMedia = () => {
    if (userProfile?.bannerUrl === null) {
      return (
        <img
          src={profile1}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    }
    const fileExtension =
      userProfile?.bannerUrl &&
      userProfile?.bannerUrl.split(".").pop()?.toLowerCase();

    if (
      fileExtension === "png" ||
      fileExtension === "jpeg" ||
      fileExtension === "jpg" ||
      fileExtension === "gif"
    ) {
      return (
        <img
          src={userProfile.bannerUrl}
          alt="User Banner"
          className="img-fluid postion-absolute banner-img"
        />
      );
    } else if (!fileExtension) {
      return (
        <img
          src={userProfile?.bannerUrl}
          alt="Default Image"
          className="img-fluid postion-absolute banner-img"
        />
      );
    } else {
      return <VideoComponent userData={userProfile} isUserMenu={false} />;
    }
  };
  return (
    <div className="modal-body">
      <div className="card card-one-1">
        <div className="background-enabler">
          {renderMyMedia()}
          <label class="switch ml-3 float-right">
            <input
              type="checkbox"
              checked={isVisible["background"]}
              onChange={() => onVisibilityChangeHandler("background")}
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div className="card-body profile-wrapper">
          <div className="d-flex  mb-3">
            <div className="sme-profile">
              <img
                className={`img-profile rounded-circle profile-img ml-1 cursor-pointer ${
                  userProfile?.offerService ? "sme-service" : null
                }`}
                src={userProfile?.picUrl || undrawProfile}
              />
              {userProfile?.offerService && (
                <div
                  className="sme-profile-icon"
                  style={{ zIndex: 11, right: "0" }}
                >
                  SME
                </div>
              )}
            </div>
            <label class="switch ml-3 float-right">
              <input
                type="checkbox"
                checked={isVisible["profile"]}
                onChange={() => onVisibilityChangeHandler("profile")}
              />
              <span class="slider round"></span>
            </label>
          </div>
          <div className="row subscription-alignment profile-settings">
            <div className="ml-3">
              <div>
                <div>
                  <p className="profile-name mb-0">
                    {userProfile?.fName || ""} {userProfile?.lName || ""}
                  </p>
                  <p className="">
                    {userProfile?.experiences
                      ? truncateText(userProfile?.experiences, 60)
                      : ""}{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="">
              <button
                className="btn btn-primary follow-btn search-follow-btn sub-btn"
                onClick={updateVisibilityHandler}
              >
                Save
              </button>
            </div>
          </div>
          {/* <div className="w-100 d-flex justify-content-between">
            <div className="social-icon">
              <FontAwesomeIcon
                icon={faLinkedin}
                className={`linkedin-icon ${
                  userProfile?.linkedinProfile ? "active-profile" : ""
                }`}
              />

              <FontAwesomeIcon
                icon={faFacebook}
                className={`linkedin-icon ${
                  userProfile?.facebookProfile ? "active-profile" : ""
                }`}
              />
              <FontAwesomeIcon
                icon={faInstagram}
                className={`linkedin-icon ${
                  userProfile?.instagramProfile ? "active-profile" : ""
                }`}
              />
              <FontAwesomeIcon
                icon={faYoutube}
                className={`linkedin-icon ${
                  userProfile?.youtubeProfile ? "active-profile" : ""
                }`}
              />
              <FontAwesomeIcon
                icon={faXTwitter}
                className={`linkedin-icon ${
                  userProfile?.xProfile ? "active-profile" : ""
                }`}
              />
            </div>
          </div> */}
          <ProfileView
            type={"edit"}
            testData={[]}
            isPublic={true}
            isVisible={isVisible}
            onVisibilityChangeHandler={onVisibilityChangeHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default PublicSettings;
